import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Button } from '@utilities';
import { submitFastTrackFeedback } from '@api/fast_tracks';

import FeedbackFooter from '../../../../components/FeedbackFooter';

import {
  negativeFastTrackFeedbackOptions,
  positiveFastTrackFeedbackOptions,
} from './utilities/helpers';

import styles from './_index.module.scss';

const TopicCardFooter = ({
  handleToggleVisibility,
  initialFeedback,
  isExcluded,
  isLoading,
  isPreviewActive = false,
  isPreviewCard = false,
  topicId,
}) => {
  const buttonText = () => {
    if (isPreviewCard) {
      return isPreviewActive ? 'Close' : 'Preview';
    }
    return isExcluded ? 'Include' : 'Exclude';
  };

  const footerMessage = () => {
    if (isPreviewCard) {
      return isPreviewActive ? (
        <span className={styles['topic-card-footer-message']}>
          This is a preview, not an actual analysis. Reach out to your account team for more
          information.
        </span>
      ) : (
        <span className={styles['topic-card-footer-message']}>
          <strong>Excluded</strong> This question is answered utilizing data outside of your current
          subscription.
        </span>
      );
    }
  };

  return (
    <div>
      <Button
        className={classNames(styles['topic-card-footer-exclude-button'], {
          [styles['is-preview']]: isPreviewCard,
          [styles['is-preview-active']]: isPreviewActive,
        })}
        disabled={isLoading}
        onClick={handleToggleVisibility}
        text={buttonText()}
        variant="secondary"
      />
      {footerMessage()}
      <FeedbackFooter
        disabled={isLoading || isPreviewCard}
        feedbackId={topicId}
        feedbackLabel={'Was this slide helpful?'}
        initialFeedback={initialFeedback}
        negativeFeedbackOptions={negativeFastTrackFeedbackOptions}
        onSubmit={submitFastTrackFeedback}
        positiveFeedbackOptions={positiveFastTrackFeedbackOptions}
      />
    </div>
  );
};

TopicCardFooter.propTypes = {
  handleToggleVisibility: PropTypes.func.isRequired,
  initialFeedback: PropTypes.shape({
    like: PropTypes.bool,
    reason: PropTypes.string,
    reasonExplanation: PropTypes.string,
  }),
  isExcluded: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isPreviewActive: PropTypes.bool,
  isPreviewCard: PropTypes.bool,
  topicId: PropTypes.number,
};

export default TopicCardFooter;
